import styled from "styled-components";

export const ApplicantReceivedStyle = styled.div`
    .receive-content {
        margin-top: ${props => props.theme.space.marginLG}px;
    }
`